import { ApiUrls } from "../types/enums";
import { DEFAULT_CULTURE, DEFAULT_TERMINAL } from "../shared/constants";

export const declineBetChanges = async ({
  authorizationKey,
  config,
}: DeclineBetChangesPayload): Promise<DeclineBetChangesResponse> => {
  const response = await fetch(ApiUrls.DECLINE_BET_CHANGES, {
    method: "POST",
    headers: {
      brandid: config.brandId,
      channelid: config.channelId,
      terminal: config?.terminal || DEFAULT_TERMINAL,
      language: config?.language || DEFAULT_CULTURE,
      "content-type": "application/json",
      ...(config.userToken
        ? {
            token: config.userToken,
            authorization: `Bearer ${config.userToken}`,
          }
        : {}),
    },
    body: JSON.stringify({
      AuthorizationKey: authorizationKey,
    }),
  });

  const text = await response.text();
  return (text.trim() ? JSON.parse(text) : { isSuccessfull: true }) as DeclineBetChangesResponse;
};
